<template>
    <v-form @submit.prevent ref="form">
    <v-alert type="success" :value="success" transition="slide-x-transition">
        Vaše údaje boli úspešne zmenené
    </v-alert>
    <v-container>
        <v-row justify="center">
            <h2>
                <span class="pa-1">Zmena profilových údajov</span>
            </h2>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="4">
                <span class="red--text">{{error}}</span>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="6">
                <v-text-field
                        label="Meno"
                        :rules="noEmpty"
                        hide-details="auto"
                        v-model=name
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="6">
                <v-text-field
                        label="Priezvisko"
                        :rules="noEmpty"
                        hide-details="auto"
                        v-model=surname
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="6">
                <v-text-field
                    :rules="rules"
                    v-model="price"
                    label="Cena za hodinu"
                    @keyup.enter="confirmPrice">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="6">
                <v-textarea
                        label="Napíš niečo o sebe..."
                        v-model=info
                > </v-textarea>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col class="text-center" cols="12">
                <v-btn @click="saveChanges()"
                color="accent" 
                >
                    Uložiť zmeny
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import store from "../../store/store";
    export default {
        name: "updateProfile",
        data: () => ({
            noEmpty: [
                value => !!value || 'Vyplňte prosím toto pole',
            ],
            number:[
                value => !!value || 'Vyplňte prosím toto pole',
                //value => (!!value && /^[0-9]+$/.test(value)) || "Povolene znaky: 0-9"
            ],
            person:{},
            check: false,
            wholeName : '',
            error : '',
            name : '',
            surname : '',
            price: '',
            info: '',
            success: false,
        }),
        methods: {
            saveChanges(){
                this.error = '';
                const params = new URLSearchParams();
                params.append('user', localStorage.getItem('loggedUserId'));
                params.append('name', this.name);
                params.append('surname', this.surname);
                params.append('price', this.price);
                params.append('info', this.info);
                axios({
                    method: 'post',
                    url: store.state.url.concat('saveProfileChanges.php'),
                    data: params
                }).then((response) => {
                    if(response.data.result == 'ok') {
                        this.alertProfileChanged()
                        this.$router.push({name: 'profile'});
                    }else{
                        this.error = response.data.error;
                    }
                });

            },
            getPersonalInfo(){
                axios.get(store.state.url.concat('getPersonalInfo.php'), {
                    params: {
                        user: localStorage.getItem('loggedUserId')
                    }
                }).then((response) => {
                        if(response.data.result == 'ok') {
                            this.person = response.data;
                            this.check = true;
                            this.name = this.person.name;
                            this.surname = this.person.surname;
                            this.price = this.person.price;
                            this.info = this.person.info;
                            this.$emit('check');
                        }
                        else{
                            this.check = false;
                            this.$emit('check');
                        }

                })
            },
            alertProfileChanged() {
                this.success = true;
                setTimeout(() => {
                    this.success = false;
                }, 2500)
            },
             confirmPrice() {
                const regex = /^[0-9]*(\.)?[0-9]+$/
                if(this.price && regex.test(this.price)){
                    console.log('price ok')
                }
            },
        },
        created(){
             this.getPersonalInfo();
        },
         computed: {
            rules() {
                const rules = [];
                const regex = /^[0-9]*(\.)?[0-9]+$/
                const rule = v => (!!v && regex.test(v)) || "Povolené znaky: 0-9 a bodka";
                const rule2 = v => (v !==null && v !== "") || "Vyplňte prosím toto pole";
                rules.push(rule2);
                rules.push(rule);//na poradi zalezi
                return rules
            }
        }
    }
</script>

<style scoped>

</style>